import { createContext, useContext } from 'react';

// Pages inside the content column reflow on their own. Anything positioned
// against the viewport instead has to subtract `offsetWidth`, and drop its own
// easing while `isResizing` is set or it trails the pointer through the drag.
export const ChatPanelLayoutContext = createContext({
	offsetWidth: 0,
	isResizing: false,
});

export const useChatPanelLayout = () => useContext(ChatPanelLayoutContext);
